module.exports = __webpack_public_path__ + "img/21.7b1e53ad.jpg";